import { ref, toRefs } from 'vue';
import { defineStore } from 'pinia';
import useStoreActions from './actions';
import useCommonGetters from '../common-getters';
import { IIndexesState, IIndexedDocumentData } from './models';

export const useIndexesStore = defineStore('indexes', () => {
  const state = ref(<IIndexesState>{
    indexes: [],
    indexesLite:[],
    IndexProperties: null,
    librariesContents: {},
    newlyCreatedIndex: 0,
    libraries: [],
    libraryOnFocus: null,
    documentTotalPages:0,
    sentenceList: [
      {
        $type: 'Artea.Document.Base.xSentence, Artea.Document.Base',
        id: '000.001.000.001',
        uri: '',
        title: 'Header',
        text: 'Header line',
        tokens: [],
        type: 'Text',
        pageNumber: 1,
        positionOnPage: '0.5;0.5;7.5;0.5;7.5;1.1;0.5;1.1',
      },
      {
        $type: 'Artea.Document.Base.xSentence, Artea.Document.Base',
        id: '000.001.000.002',
        uri: '',
        title: 'Subject line',
        text: 'Examen national de bacalaureat 2025',
        tokens: [],
        type: 'Text',
        pageNumber: 1,
        positionOnPage: '0.5;1.3;7.5;1.3;7.5;1.8;0.5;1.8',
      },
      {
        $type: 'Artea.Document.Base.xSentence, Artea.Document.Base',
        id: '000.001.000.003',
        uri: '',
        title: 'Problem 1',
        text: 'Determinati termenul al n-lea',
        tokens: [],
        type: 'Text',
        pageNumber: 1,
        positionOnPage: '0.7;2.0;5.8;2.0;5.8;2.4;0.7;2.4',
      },
      {
        $type: 'Artea.Document.Base.xSentence, Artea.Document.Base',
        id: '000.001.000.004',
        uri: '',
        title: 'Problem 2',
        text: 'Se considera functia f:R->R',
        tokens: [],
        type: 'Text',
        pageNumber: 1,
        positionOnPage: '0.7;2.6;5.8;2.6;5.8;3.0;0.7;3.0',
      },
      {
        $type: 'Artea.Document.Base.xSentence, Artea.Document.Base',
        id: '000.001.000.005',
        uri: '',
        title: 'Problem 3',
        text: 'Rezolvati in numere reale ecuatia',
        tokens: [],
        type: 'Text',
        pageNumber: 1,
        positionOnPage: '0.7;3.2;5.8;3.2;5.8;3.6;0.7;3.6',
      },
      {
        $type: 'Artea.Document.Base.xSentence, Artea.Document.Base',
        id: '000.001.000.006',
        uri: '',
        title: 'Subiectul II',
        text: 'SUBIECTUL al II-lea',
        tokens: [],
        type: 'Text',
        pageNumber: 1,
        positionOnPage: '0.5;5.3;7.0;5.3;7.0;5.7;0.5;5.7',
      },
      {
        $type: 'Artea.Document.Base.xSentence, Artea.Document.Base',
        id: '000.001.000.007',
        uri: '',
        title: 'Subiectul III',
        text: 'SUBIECTUL al III-lea',
        tokens: [],
        type: 'Text',
        pageNumber: 1,
        positionOnPage: '0.5;8.5;7.0;8.5;7.0;8.9;0.5;8.9',
      },
    ],
    documentPageImageBase64:'',
    documentDetails: null,
    indexesIds: [],
    isCreateIndexDialogVisible: false,
    isUpdateIndexDialogVisible: false,
    showLibraryList: false,
    sourceToIndex: {
      id: 0,
      name: undefined,
      description: undefined,
      metadata: null,
      directory: '',
      library: '',
      limit: 500,
      lastUpdate: '2000-01-01',
      enableGenerateThumbnail: true,
      enableCopyFileToLake: true,
      enableCopyLogsToLake: true,
      enableCopyErrorsToLake: true,
      orderedTextCrackers: [
        { name: 'AzureDocumentIntelligence', connectionKey: 'AzureAIDocument;OpenAIModel41', fileTypes: null },
        { name: 'Tika', connectionKey: null, fileTypes: null },
        { name: 'Iron', connectionKey: null, fileTypes: null },
      ],
      countLimit: 10,
      memoryLimit: 100,
      waitSec: 10,
      initDestination: true,
      searchservice: 'ragdemonuovo',
      searchKeyVault: null,
      titleFieldName: null,
      contentFieldNames: null,
      vectorFieldNames: null,
      urlFieldName: null,
      semanticConfiguration: null,
      shouldRestrictResultScope: undefined,
    },
    documentFileName: ''
  });

  return {
    ...toRefs(state.value),
    ...useCommonGetters<IIndexesState>(state),
    ...useStoreActions(state),
  };
});
